(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nobl-native-review"] && !Shopify.designMode) return;
  try {
    (() => {
const selector = 'body.page-native-in-place:has(.wk-review--compact) tolstoy-widget[data-tolstoy-widget-id="cxt424l5z1sgx"] .tolstoy-stories-tiles-container';
  const mount = () => {
    const track = document.querySelector(selector);
    if (!track) return false;
    if (track.dataset.wkTicker) return true;
    const originals = Array.from(track.children).filter(el => el.classList.contains('tolstoy-stories-tile'));
    if (originals.length < 2) return false;
    track.dataset.wkTicker = 'true';
    const clones = originals.map(original => {
      const clone = original.cloneNode(true);
      clone.dataset.wkClone = 'true';
      clone.setAttribute('aria-hidden', 'true');
      clone.removeAttribute('aria-label');
      clone.removeAttribute('id');
      clone.tabIndex = -1;
      clone.querySelectorAll('[id]').forEach(el => el.removeAttribute('id'));
      clone.querySelectorAll('[tabindex]').forEach(el => el.tabIndex = -1);
      clone.addEventListener('click', event => {
        event.preventDefault();
        event.stopPropagation();
        original.click();
      });
      track.appendChild(clone);
      return clone;
    });
    let distance = 0, position = track.scrollLeft, lastWritten = position;
    let frame = 0, previous = 0, visible = false, hovering = false, dragging = false, resumeAt = 0;
    const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)');
    const measure = () => {
      distance = clones[0].offsetLeft - originals[0].offsetLeft;
    };
    const stop = () => {
      cancelAnimationFrame(frame);
      frame = 0;
      previous = 0;
    };
    const tick = time => {
      frame = 0;
      if (!track.isConnected) {
        visibility.disconnect();
        resize.disconnect();
        return;
      }
      const elapsed = previous ? Math.min(time - previous, 50) : 0;
      previous = time;
      const player = document.querySelector('tolstoy-widget[data-tolstoy-player-overlay-root="cxt424l5z1sgx"] [role="dialog"]');
      const playing = player && player.getAttribute('aria-hidden') !== 'true' && getComputedStyle(player).display !== 'none';
      if (Math.abs(track.scrollLeft - lastWritten) > 2) position = track.scrollLeft;
      if (!hovering && !dragging && !playing && time >= resumeAt && distance > 0) {
        position += elapsed * 0.0425;
        if (position >= distance) position %= distance;
        track.scrollLeft = position;
        lastWritten = track.scrollLeft;
      } else {
        position = track.scrollLeft;
        lastWritten = position;
      }
      if (visible && !document.hidden && !reduceMotion.matches) frame = requestAnimationFrame(tick);
    };
    const start = () => {
      if (visible && !document.hidden && !reduceMotion.matches && !frame) frame = requestAnimationFrame(tick);
    };
    const refresh = () => {
      stop();
      start();
    };
    const visibility = new IntersectionObserver(entries => {
      visible = entries[0].isIntersecting;
      refresh();
    }, { threshold: 0.05 });
    const resize = new ResizeObserver(measure);
    visibility.observe(track);
    resize.observe(track);
    track.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') hovering = true; });
    track.addEventListener('pointerleave', () => { hovering = false; });
    track.addEventListener('pointerdown', () => { dragging = true; });
    window.addEventListener('pointerup', () => { if (dragging) { dragging = false; resumeAt = performance.now() + 1500; } }, { passive: true });
    track.addEventListener('pointercancel', () => { dragging = false; resumeAt = performance.now() + 1500; });
    track.addEventListener('wheel', () => { resumeAt = performance.now() + 1500; }, { passive: true });
    track.addEventListener('keydown', () => { resumeAt = performance.now() + 3000; });
    document.addEventListener('visibilitychange', refresh);
    reduceMotion.addEventListener('change', refresh);
    measure();
    return true;
  };
  const boot = () => {
    if (!document.querySelector('.wk-review--compact') || mount()) return;
    const observer = new MutationObserver(() => { if (mount()) observer.disconnect(); });
    observer.observe(document.querySelector('[id$="__weekender_video_reviews"]') || document.querySelector('.product__info-container') || document.body, { childList: true, subtree: true });
    window.addEventListener('pagehide', () => observer.disconnect(), { once: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();


(() => {
  const mountProof = () => {
    if (!document.querySelector('.wk-review--compact')) return;
    const root = document.querySelector('.product__info-container [data-oke-star-rating]');
    if (!root || root.dataset.wkProofObserved) return;
    root.dataset.wkProofObserved = 'true';
    const render = () => {
      const button = root.querySelector('.oke-is-clickable');
      const originalStars = button?.querySelector(':scope > .oke-sr-stars');
      const summary = button?.querySelector(':scope > .oke-sr-count .custom-review-summary');
      const sourceRating = button?.querySelector(':scope > .oke-sr-rating');
      const sourceCount = button?.querySelector(':scope > .oke-sr-count');
      const text = summary?.textContent || sourceCount?.textContent || '';
      const match = text.match(/([0-9.]+)\/5\s*[-–]?\s*([\d,]+)/);
      const rating = match?.[1] || sourceRating?.textContent.trim();
      const count = match?.[2] || text.match(/[\d,]+/)?.[0];
      if (!button || !originalStars || !rating || !count) return;
      observer.disconnect();
      let proof = button.querySelector(':scope > .wk-proof');
      if (!proof) {
        proof = document.createElement('span');
        proof.className = 'wk-proof';
        proof.setAttribute('aria-hidden', 'true');
        const stars = originalStars.cloneNode(true);
        stars.classList.add('wk-proof-stars');
        const score = document.createElement('span');
        score.className = 'wk-proof-rating';
        const reviews = document.createElement('span');
        reviews.className = 'wk-proof-count';
        const sold = document.createElement('span');
        sold.className = 'wk-proof-sold';
        sold.textContent = '1m+ Sold';
        proof.append(stars, score, reviews, sold);
        button.appendChild(proof);
      }
      proof.querySelector('.wk-proof-rating').textContent = rating + '/5';
      proof.querySelector('.wk-proof-count').textContent = ' - ' + count + ' Verified Reviews';
      button.classList.add('wk-proof-ready');
      button.setAttribute('aria-label', 'Rated ' + rating + ' out of 5 stars. ' + count + ' Verified Reviews. 1m+ Sold. Click to scroll to reviews');
      observer.observe(root, { childList: true, subtree: true, characterData: true });
    };
    const observer = new MutationObserver(render);
    observer.observe(root, { childList: true, subtree: true, characterData: true });
    render();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mountProof, { once: true });
  else mountProof();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nobl-pdp-v2-review"] && !Shopify.designMode) return;
  try {
    (() => {
const selector = 'body:is(.page-weekender-compact,.page-weekender-compact-v2,.page-weekender-compact-v3,.page-weekender-compact-v4):has(.wk-review--compact) tolstoy-widget[data-tolstoy-widget-id="cxt424l5z1sgx"] .tolstoy-stories-tiles-container';
  const mount = () => {
    const track = document.querySelector(selector);
    if (!track) return false;
    if (track.dataset.wkTicker) return true;
    const originals = Array.from(track.children).filter(el => el.classList.contains('tolstoy-stories-tile'));
    if (originals.length < 2) return false;
    track.dataset.wkTicker = 'true';
    const clones = originals.map(original => {
      const clone = original.cloneNode(true);
      clone.dataset.wkClone = 'true';
      clone.setAttribute('aria-hidden', 'true');
      clone.removeAttribute('aria-label');
      clone.removeAttribute('id');
      clone.tabIndex = -1;
      clone.querySelectorAll('[id]').forEach(el => el.removeAttribute('id'));
      clone.querySelectorAll('[tabindex]').forEach(el => el.tabIndex = -1);
      clone.addEventListener('click', event => {
        event.preventDefault();
        event.stopPropagation();
        original.click();
      });
      track.appendChild(clone);
      return clone;
    });
    let distance = 0, position = track.scrollLeft, lastWritten = position;
    let frame = 0, previous = 0, visible = false, hovering = false, dragging = false, resumeAt = 0;
    const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)');
    const measure = () => {
      distance = clones[0].offsetLeft - originals[0].offsetLeft;
    };
    const stop = () => {
      cancelAnimationFrame(frame);
      frame = 0;
      previous = 0;
    };
    const tick = time => {
      frame = 0;
      if (!track.isConnected) {
        visibility.disconnect();
        resize.disconnect();
        return;
      }
      const elapsed = previous ? Math.min(time - previous, 50) : 0;
      previous = time;
      const player = document.querySelector('tolstoy-widget[data-tolstoy-player-overlay-root="cxt424l5z1sgx"] [role="dialog"]');
      const playing = player && player.getAttribute('aria-hidden') !== 'true' && getComputedStyle(player).display !== 'none';
      if (Math.abs(track.scrollLeft - lastWritten) > 2) position = track.scrollLeft;
      if (!hovering && !dragging && !playing && time >= resumeAt && distance > 0) {
        position += elapsed * 0.0425;
        if (position >= distance) position %= distance;
        track.scrollLeft = position;
        lastWritten = track.scrollLeft;
      } else {
        position = track.scrollLeft;
        lastWritten = position;
      }
      if (visible && !document.hidden && !reduceMotion.matches) frame = requestAnimationFrame(tick);
    };
    const start = () => {
      if (visible && !document.hidden && !reduceMotion.matches && !frame) frame = requestAnimationFrame(tick);
    };
    const refresh = () => {
      stop();
      start();
    };
    const visibility = new IntersectionObserver(entries => {
      visible = entries[0].isIntersecting;
      refresh();
    }, { threshold: 0.05 });
    const resize = new ResizeObserver(measure);
    visibility.observe(track);
    resize.observe(track);
    track.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') hovering = true; });
    track.addEventListener('pointerleave', () => { hovering = false; });
    track.addEventListener('pointerdown', () => { dragging = true; });
    window.addEventListener('pointerup', () => { if (dragging) { dragging = false; resumeAt = performance.now() + 1500; } }, { passive: true });
    track.addEventListener('pointercancel', () => { dragging = false; resumeAt = performance.now() + 1500; });
    track.addEventListener('wheel', () => { resumeAt = performance.now() + 1500; }, { passive: true });
    track.addEventListener('keydown', () => { resumeAt = performance.now() + 3000; });
    document.addEventListener('visibilitychange', refresh);
    reduceMotion.addEventListener('change', refresh);
    measure();
    return true;
  };
  const boot = () => {
    if (!document.querySelector('.wk-review--compact') || mount()) return;
    const observer = new MutationObserver(() => { if (mount()) observer.disconnect(); });
    observer.observe(document.querySelector('[id$="__weekender_video_reviews"]') || document.querySelector('.product__info-container') || document.body, { childList: true, subtree: true });
    window.addEventListener('pagehide', () => observer.disconnect(), { once: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();


(() => {
  const mountProof = () => {
    if (!document.querySelector('.wk-review--compact')) return;
    const root = document.querySelector('.product__info-container [data-oke-star-rating]');
    if (!root || root.dataset.wkProofObserved) return;
    root.dataset.wkProofObserved = 'true';
    const render = () => {
      const button = root.querySelector('.oke-is-clickable');
      const originalStars = button?.querySelector(':scope > .oke-sr-stars');
      const summary = button?.querySelector(':scope > .oke-sr-count .custom-review-summary');
      const sourceRating = button?.querySelector(':scope > .oke-sr-rating');
      const sourceCount = button?.querySelector(':scope > .oke-sr-count');
      const text = summary?.textContent || sourceCount?.textContent || '';
      const match = text.match(/([0-9.]+)\/5\s*[-–]?\s*([\d,]+)/);
      const rating = match?.[1] || sourceRating?.textContent.trim();
      const count = match?.[2] || text.match(/[\d,]+/)?.[0];
      if (!button || !originalStars || !rating || !count) return;
      observer.disconnect();
      let proof = button.querySelector(':scope > .wk-proof');
      if (!proof) {
        proof = document.createElement('span');
        proof.className = 'wk-proof';
        proof.setAttribute('aria-hidden', 'true');
        const stars = originalStars.cloneNode(true);
        stars.classList.add('wk-proof-stars');
        const score = document.createElement('span');
        score.className = 'wk-proof-rating';
        const reviews = document.createElement('span');
        reviews.className = 'wk-proof-count';
        const sold = document.createElement('span');
        sold.className = 'wk-proof-sold';
        sold.textContent = '1m+ Sold';
        proof.append(stars, score, reviews, sold);
        button.appendChild(proof);
      }
      proof.querySelector('.wk-proof-rating').textContent = rating + '/5';
      proof.querySelector('.wk-proof-count').textContent = ' - ' + count + ' Verified Reviews';
      button.classList.add('wk-proof-ready');
      button.setAttribute('aria-label', 'Rated ' + rating + ' out of 5 stars. ' + count + ' Verified Reviews. 1m+ Sold. Click to scroll to reviews');
      observer.observe(root, { childList: true, subtree: true, characterData: true });
    };
    const observer = new MutationObserver(render);
    observer.observe(root, { childList: true, subtree: true, characterData: true });
    render();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mountProof, { once: true });
  else mountProof();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nobl-pdp-v3-review"] && !Shopify.designMode) return;
  try {
    (() => {
  const selector = 'body:has(.wk-review--compact) tolstoy-widget[data-tolstoy-widget-id="cxt424l5z1sgx"] .tolstoy-stories-tiles-container';
  const mount = () => {
    const track = document.querySelector(selector);
    if (!track) return false;
    if (track.dataset.wkTicker) return true;
    const originals = Array.from(track.children).filter(el => el.classList.contains('tolstoy-stories-tile'));
    if (originals.length < 2) return false;
    track.dataset.wkTicker = 'true';
    const clones = originals.map(original => {
      const clone = original.cloneNode(true);
      clone.dataset.wkClone = 'true';
      clone.setAttribute('aria-hidden', 'true');
      clone.removeAttribute('aria-label');
      clone.removeAttribute('id');
      clone.tabIndex = -1;
      clone.querySelectorAll('[id]').forEach(el => el.removeAttribute('id'));
      clone.querySelectorAll('[tabindex]').forEach(el => el.tabIndex = -1);
      clone.addEventListener('click', event => {
        event.preventDefault();
        event.stopPropagation();
        original.click();
      });
      track.appendChild(clone);
      return clone;
    });
    let distance = 0, position = track.scrollLeft, lastWritten = position;
    let frame = 0, previous = 0, visible = false, hovering = false, dragging = false, resumeAt = 0;
    const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)');
    const measure = () => {
      distance = clones[0].offsetLeft - originals[0].offsetLeft;
    };
    const stop = () => {
      cancelAnimationFrame(frame);
      frame = 0;
      previous = 0;
    };
    const tick = time => {
      frame = 0;
      if (!track.isConnected) {
        visibility.disconnect();
        resize.disconnect();
        return;
      }
      const elapsed = previous ? Math.min(time - previous, 50) : 0;
      previous = time;
      const player = document.querySelector('tolstoy-widget[data-tolstoy-player-overlay-root="cxt424l5z1sgx"] [role="dialog"]');
      const playing = player && player.getAttribute('aria-hidden') !== 'true' && getComputedStyle(player).display !== 'none';
      if (Math.abs(track.scrollLeft - lastWritten) > 2) position = track.scrollLeft;
      if (!hovering && !dragging && !playing && time >= resumeAt && distance > 0) {
        position += elapsed * 0.0425;
        if (position >= distance) position %= distance;
        track.scrollLeft = position;
        lastWritten = track.scrollLeft;
      } else {
        position = track.scrollLeft;
        lastWritten = position;
      }
      if (visible && !document.hidden && !reduceMotion.matches) frame = requestAnimationFrame(tick);
    };
    const start = () => {
      if (visible && !document.hidden && !reduceMotion.matches && !frame) frame = requestAnimationFrame(tick);
    };
    const refresh = () => {
      stop();
      start();
    };
    const visibility = new IntersectionObserver(entries => {
      visible = entries[0].isIntersecting;
      refresh();
    }, { threshold: 0.05 });
    const resize = new ResizeObserver(measure);
    visibility.observe(track);
    resize.observe(track);
    track.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') hovering = true; });
    track.addEventListener('pointerleave', () => { hovering = false; });
    track.addEventListener('pointerdown', () => { dragging = true; });
    window.addEventListener('pointerup', () => { if (dragging) { dragging = false; resumeAt = performance.now() + 1500; } }, { passive: true });
    track.addEventListener('pointercancel', () => { dragging = false; resumeAt = performance.now() + 1500; });
    track.addEventListener('wheel', () => { resumeAt = performance.now() + 1500; }, { passive: true });
    track.addEventListener('keydown', () => { resumeAt = performance.now() + 3000; });
    document.addEventListener('visibilitychange', refresh);
    reduceMotion.addEventListener('change', refresh);
    measure();
    return true;
  };
  const boot = () => {
    if (!document.querySelector('.wk-review--compact') || mount()) return;
    const observer = new MutationObserver(() => { if (mount()) observer.disconnect(); });
    observer.observe(document.querySelector('[id$="__weekender_video_reviews"]') || document.querySelector('.product__info-container') || document.body, { childList: true, subtree: true });
    window.addEventListener('pagehide', () => observer.disconnect(), { once: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();


(() => {
  const mountProof = () => {
    if (!document.querySelector('.wk-review--compact')) return;
    const root = document.querySelector('.product__info-container [data-oke-star-rating]');
    if (!root || root.dataset.wkProofObserved) return;
    root.dataset.wkProofObserved = 'true';
    const render = () => {
      const button = root.querySelector('.oke-is-clickable');
      const originalStars = button?.querySelector(':scope > .oke-sr-stars');
      const summary = button?.querySelector(':scope > .oke-sr-count .custom-review-summary');
      const sourceRating = button?.querySelector(':scope > .oke-sr-rating');
      const sourceCount = button?.querySelector(':scope > .oke-sr-count');
      const text = summary?.textContent || sourceCount?.textContent || '';
      const match = text.match(/([0-9.]+)\/5\s*[-–]?\s*([\d,]+)/);
      const rating = match?.[1] || sourceRating?.textContent.trim();
      const count = match?.[2] || text.match(/[\d,]+/)?.[0];
      if (!button || !originalStars || !rating || !count) return;
      observer.disconnect();
      let proof = button.querySelector(':scope > .wk-proof');
      if (!proof) {
        proof = document.createElement('span');
        proof.className = 'wk-proof';
        proof.setAttribute('aria-hidden', 'true');
        const stars = originalStars.cloneNode(true);
        stars.classList.add('wk-proof-stars');
        const score = document.createElement('span');
        score.className = 'wk-proof-rating';
        const reviews = document.createElement('span');
        reviews.className = 'wk-proof-count';
        const sold = document.createElement('span');
        sold.className = 'wk-proof-sold';
        sold.textContent = '1m+ Sold';
        proof.append(stars, score, reviews, sold);
        button.appendChild(proof);
      }
      proof.querySelector('.wk-proof-rating').textContent = rating + '/5';
      proof.querySelector('.wk-proof-count').textContent = ' - ' + count + ' Verified Reviews';
      button.classList.add('wk-proof-ready');
      button.setAttribute('aria-label', 'Rated ' + rating + ' out of 5 stars. ' + count + ' Verified Reviews. 1m+ Sold. Click to scroll to reviews');
      observer.observe(root, { childList: true, subtree: true, characterData: true });
    };
    const observer = new MutationObserver(render);
    observer.observe(root, { childList: true, subtree: true, characterData: true });
    render();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mountProof, { once: true });
  else mountProof();
})();
  } catch(e) { console.error(e); }
})();

})();
